import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UxDesignRoutingModule } from './ux-design-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UxDesignRoutingModule
  ]
})
export class UxDesignModule { }
